export enum TicketsDetailsOpenedSections {
  Info = "ticket_details_section_info_opened",
  Tags = "ticket_details_section_tags_opened",
  CustomFields = "ticket_details_section_custom_fields_opened",
  Responsibility = "ticket_details_section_responsibility_opened",
  Requester = "ticket_details_section_requester_opened",
  Recent = "ticket_details_section_recent_opened",
  Widgets = "ticket_details_section_widget_openings_opened",
}

export const DISPLAYING_ONBOARDING_DRAWER_TRIAL_DAYS_LIMIT = 99;
